import * as types from "../constants/ActionTypes";
var initialState = [];

var listStore = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_DATA_LIST_STORE:
      state = action.listStore;
      return [...state];
    default:
      return [...state];
  }
};
export default listStore;
